import { handleActions }                   from 'redux-actions';
import { enableEditMode, disableEditMode } from '../actions';


/**
 * @todo TESTS: Add all
 */
const inEditMode = handleActions(
  {

    [enableEditMode]: (state) => {

      if (true === state) {

        return state;

      }

      return true;

    },

    [disableEditMode]: (state) => {

      if (false === state) {

        return state;

      }

      return false;

    },

  },

  false
);


export default inEditMode;


// WEBPACK FOOTER //
// ./src/modules/editableContent/reducers/inEditMode.js